import React from "react";
import "../components/doctorSpecialistTable.css";

const DoctorSpecialistTable = ({
  specialists,
  onEditSpecialistClicked,
  onDeleteSpecialistClicked,
}) => {
  const editSpecialist = (specialist) => {
    onEditSpecialistClicked(specialist);
  };

  const deleteSpecialist = (specialist) => {
    onDeleteSpecialistClicked(specialist);
  };

  return (
    <div className="doctor-specialist-table-container">
      <table className="doctor-specialist-table">
        <thead>
          <tr>
            <th width="100px">No Poli</th>
            <th>Nama Poli</th>
            <th width="150px">Actions</th>
          </tr>
        </thead>
        <tbody>
        {specialists.length > 0 ? (
            specialists.map((specialist, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{specialist.doctor_specialist_name}</td>
                <td>
                  <button
                    className="edit-doctor-specialist-button"
                    onClick={() => {
                      editSpecialist(specialist);
                    }}
                  >
                    Edit
                  </button>
                  <button
                    className="delete-doctor-specialist-button"
                    onClick={() => {
                      deleteSpecialist(specialist);
                    }}
                  >
                    Hapus
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3" style={{ textAlign: "center" }}>
                Data tidak tersedia
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default DoctorSpecialistTable;
